import {hasFullAccess} from 'ultra/helpers/auth';

import UserHistoryLink from '../../../../UserHistoryLink'
import {useGlobalCustomContext} from '../../../../../../../Helpers/context';
import {isYoursAccount} from '../../../../../../../Helpers/user';
import NodeDetails from '../../../Components/NodeDetails'

export default function Template(props) {
    const {values} = props;

    const {userState} = useGlobalCustomContext();

    const isDocumentOwner = isYoursAccount(userState, values?.details?.owner);
    const fullAccess = hasFullAccess(userState?.user);
    const noFullAccess = !fullAccess;

    const initByCurrentUser = isYoursAccount(userState, values._init_by);

    if (initByCurrentUser) {
        return <div className="NotificationTitle">
            <>Ви перейменували </>
            {/* {!values.details && <> сторінку</>} */}

            <NodeDetails values={values} fullAccess={fullAccess} isDocumentOwner={isDocumentOwner} />
            {values?.details?._prev_name && <>
                . Поперднє ім'я - {values.details._prev_name}
            </>}
        </div>
    } 

    return <div className="NotificationTitle">
        <UserHistoryLink onlyText={noFullAccess} id={values?._init_by} name={values?._init_by_name} />
        <> перейменував </>
        <NodeDetails values={values} fullAccess={fullAccess} isDocumentOwner={isDocumentOwner} />
        {values?.details?._prev_name && <>
            . Поперднє ім'я - {values.details._prev_name}
        </>}
    </div>
}
